export let INVENTORY_UPSELL_EDIT_MODES = /*#__PURE__*/function (INVENTORY_UPSELL_EDIT_MODES) {
  INVENTORY_UPSELL_EDIT_MODES["INFO"] = "INFO";
  INVENTORY_UPSELL_EDIT_MODES["EDIT_REGULAR_ITEM"] = "EDIT_REGULAR_ITEM";
  INVENTORY_UPSELL_EDIT_MODES["EDIT_BOX"] = "EDIT_BOX";
  INVENTORY_UPSELL_EDIT_MODES["INVENTORY_FORM"] = "INVENTORY_FORM";
  return INVENTORY_UPSELL_EDIT_MODES;
}({});